module.exports = __webpack_public_path__ + "img/vimo-mc-sm.a70221e1.svg";